import script from "./PageContent.vue?vue&type=script&setup=true&lang=js"
export * from "./PageContent.vue?vue&type=script&setup=true&lang=js"

import "./PageContent.vue?vue&type=style&index=0&id=6dba2b86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dba2b86"]])

export default __exports__